export const timeUnitParams = [
  "timeUnitCacMobile",
  "timeUnitFrMobile",
  "timeUnitImpsMobile",
  "timeUnitCpcMobile",
  "timeUnitCiMobile",
  "timeUnitCoMobile",
  "timeUnitCoiMobile",
  "timeUnitEpcMobile",
  "timeUnitCpaiMobile",
  "timeUnitCpapvMobile",
  "timeUnitAcpaiMobile",
  "timeUnitCrMobile",
  "timeUnitFtdMobile",
  "timeUnitGftdqftdMobile",
  "timeUnitPftdMobile",
  "timeUnitNrpfMobile",
  "timeUnitPvMobile",
  "timeUnitPMobile",
  "timeUnitSMobile",
  "timeUnitTiMobile",
  "timeUnitRsMobile",
  "timeUnitRspvMobile",
  "timeUnitArspdMobile",
];
export const removeParamsFromList = (
  params: URLSearchParams,
  keysToRemove: string[],
) => {
  const updated = new URLSearchParams(params);
  keysToRemove.forEach((key) => {
    updated.delete(key);
  });
  return updated;
};
